'use client'
import {
  useConfig_default
} from "./chunk-AVLZHNEN.mjs";

// src/hooks/useTranslation.ts
var useTranslation = (...args) => {
  return useConfig_default().i18n.useTranslation(...args);
};

export {
  useTranslation
};
//# sourceMappingURL=chunk-B7XSKPD3.mjs.map